<template>
  <el-dialog title="标签编辑" :visible.sync="dialogVisible" width="650px" :before-close="handleClose"
    :close-on-click-modal="false">
    <el-form ref="form" :model="editParam" :rules="rules" label-width="100px">
      <el-form-item label="标签:" prop="tags">
        <tag-selector v-model="editParam.tags" :tagList="tagList"></tag-selector>
      </el-form-item>
      <el-form-item label="更新状态:" prop="updateStatus">
        <el-select v-model="editParam.updateStatus" placeholder="请选择更新状态" size="small">
          <el-option label="覆盖写入" :value="1"></el-option>
          <el-option label="追加写入" :value="2"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="submitDate">确 认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import API from "@/api";
import TagSelector from "@/components/tagSelector";
export default {
  components: {
    TagSelector,
  },
  data() {
    return {
      dialogVisible: false,
      tagList: [],
      editParam: {
        ids: [],
        tags: [],
        updateStatus: undefined,
      },
      rules: {
        tags: [
          { required: true, message: "请添加标签", trigger: "change" },
        ],
        updateStatus: [
          { required: true, message: "请选择更新状态", trigger: "change" },
        ],
      }
    }
  },
  mounted() {
    this.getTagList()
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields();
    },
    open(data) {
      this.dialogVisible = true;
      this.editParam.ids = data.map(item => item.id)
    },
    submitDate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          API.updateTags(this.editParam).then(res => {
            if (res.code === 200) {
              this.$message.success('添加成功')
              this.handleClose()
              this.$emit('pageReload')
            }
          })
        }
      })
    },
    getTagList() {
      API.queryTagList({}).then((res) => {
        if (res.code === 200) {
          this.tagList = res.data.list;
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped></style>